export const CONFIRM = 'Confirm';
export const YES = 'Yes';
